
//30有誠的按鈕群
import React, { useState, useEffect, ReactEventHandler, Component } from "react";
import { Close } from './SVG'
interface HModalProps {
    title?: String 
    children?: String | React.ReactNode
    //children?: JSX.Element|JSX.Element[];
    className?: string
    show?: boolean
    type?: string
    showCross: boolean | true
    cancel?: () => void
    confirm?: () => void
    confirmText?: string | null
}

export class HibModal extends Component<HModalProps> {
    render() {
        const { title, children, show, type, showCross, className, cancel, confirm, confirmText, ...props } = this.props as HModalProps;
        if (show) {
            return (
                <div
                    className={"hibModal "+ (type != "photo" && "smallBox ")  + (show ? " open" : " ") + (className ? " " + className : " ") + type}
                    onClick={() => { }/*(type=="photo" ? cancel:()=>{})*/}
                >
                    <div className="modalContent">
                        {
                            showCross &&
                            <div className="modalHeader">
                                
                                <button className="close" onClick={cancel}>
                                    <Close />
                                </button>
                                {
                                    title &&
                                    <h4>{title}</h4>
                                }
                            </div>
                        }
                        <div className="modalBody">
                            <div className="confirmMesg">
                                {children}
                            </div>
                            <div className="btns">
                                {
                                    type == "photo" ?
                                        <></> :
                                        type == "confirm" ?
                                            <button className="hibBtn long large main" onClick={confirm}>
                                                {
                                                    confirmText ?
                                                        confirmText :
                                                        "我知道了"
                                                }
                                            </button>
                                            :
                                            <>
                                                <button className="hibBtn long large main" onClick={confirm}>是</button>
                                                <button className="hibBtn long large red" onClick={cancel}>否</button>
                                            </>
                                }
                            </div>
                        </div>
                    </div>
                </div>
            )
        } else {
            return null
        }
    }
}
